import React from 'react';
import { Grid, GridProps } from '@mui/material';

interface HouseCollectionGridProps extends GridProps {
  horizontalOnMobile?: boolean;
}

const HouseCollectionGrid: React.FC<HouseCollectionGridProps> = ({
  children,
  sx,
  horizontalOnMobile = true,
  ...gridProps
}) => (
  <Grid
    container
    {...gridProps}
    sx={horizontalOnMobile ? {
      flexWrap: { xs: 'nowrap', sm: 'wrap' },
      overflowX: { xs: 'auto', sm: 'visible' },
      scrollSnapType: { xs: 'x mandatory', sm: 'none' },
      pb: 1,
      px: { xs: 0.5, sm: 0 },
      mx: { xs: -0.5, sm: 0 },
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': { display: 'none' },
      ...sx,
    } : sx}
  >
    {children}
  </Grid>
);

export default HouseCollectionGrid;